import * as React from 'react';
import * as Colors from '../../consts/variables';
import { HeartIcon } from '../Icons/HeartIcon';
import { Link } from '../Link';
import { TrackComponent } from '../TrackComponent';

const styles: Record<string, React.CSSProperties> = {
    icon: {
        margin: '0 5px',
        textDecoration: 'none',
        position: 'relative',
        display: 'flex',
        alignItems: 'flex-start',
    },
    favCountWrapper: {
        color: Colors.white,
        transform: 'translate(0%,-25%)',
        position: 'relative',
        borderRadius: '50%',
        background: Colors.red,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 14,
        marginLeft: -10,
    },
    favCount: {
        fontSize: '12px',
        lineHeight: '12px',
        padding: '0px 3px',
    },
    favoriteCircle: {
        paddingTop: '100%',
    },
};

interface SelfProps {
    count: number;
    pageUrl: string;
}

export const Favorites = (props: SelfProps) => {
    const TrackableLink = TrackComponent(Link, {
        category: 'mobile-favorites',
        action: 'favorites icon',
    });

    return (
        <TrackableLink style={styles.icon} href={`/${props.pageUrl}`}>
            <HeartIcon style={styles.svg} width={28} height={28} />
            {props.count > 0 && (
                <div style={styles.favCountWrapper}>
                    <span style={styles.favoriteCircle} />
                    <span style={styles.favCount}>{props.count}</span>
                </div>
            )}
        </TrackableLink>
    );
};
